class ProductFeaturedTabContent extends HTMLElement {
  constructor() {
    super();
    this.boundNavEventHandler = this.navEventHandler.bind(this);
  }

  connectedCallback() {
    this.navigation = this.querySelector(".product-featured-tab-content--nav");

    if (!this.navigation) return;

    this.navigation.addEventListener("click", this.boundNavEventHandler);
  }

  navEventHandler(event) {
    const btn = event.target.closest("button");
    if (!btn || btn.classList.contains("active-tab")) return;

    const { tabHandle } = btn.dataset;
    this.resetNav(btn);
    this.resetContent(tabHandle);
  }

  resetNav(activeBtn) {
    const prevActive = this.navigation.querySelector("button.active-tab");
    prevActive?.setAttribute("aria-selected", "false");
    prevActive.classList.remove("active-tab");
    activeBtn.classList.add("active-tab");
    activeBtn.setAttribute("aria-selected", "true");

    if (window.matchMedia("(max-width: 1200px)").matches) {
      activeBtn.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }

  resetContent(tabHandle) {
    const prevActive = this.querySelector(
      ".product-featured-tab-content--tab.active-tab",
    );
    const nextActive = this.querySelector(
      `.product-featured-tab-content--tab[data-tab-handle="${tabHandle}"]`,
    );

    prevActive.classList.remove("active-tab");
    prevActive.setAttribute("hidden", "");
    nextActive.classList.add("active-tab");
    nextActive.removeAttribute("hidden");
  }

  disconnectedCallback() {
    if (!this.navigation) return;
    this.navigation.removeEventListener("click", this.boundNavEventHandler);
  }
}
customElements.define(
  "product-featured-tab-content",
  ProductFeaturedTabContent,
);
